<template>
  <div class="room-item h-outer-border around-4 bw3 h-bg blue-2">
    <div class="row-top">
      <div class="status">
        <div class="room-status-icon h-title right nowrap"
             :data-title="`${ownerNick ? '房主：' + ownerNick : ''}`"
             :class="[getRoomStatusClassName(roomInfo)]">
        </div>
      </div>
      <div class="title sep-border-left sep-border-right" :title="roomInfo.name">
        {{roomInfo.name}}
      </div>
      <div class="progress sep-border-left">{{roomInfo.current}}/{{roomInfo.total}}</div>
    </div>
    <div class="row-bottom">
      <div class="status-field">
        <div class="h-tag">
          <div>{{DRAFT_MODE_NAME[roomInfo.draftMode]}}</div>
        </div>
        <div v-if="roomInfo.status === 3" class="h-tag">
          <div>{{ isAIRoom ? 'PVE' : 'PVP'}}</div>
        </div>
        <div v-if="roomInfo.pvpBounty"
             class="flex items-center h-title nowrap"
             :data-title="`PVP悬赏金：${roomInfo.pvpBounty}`"
             style="margin-left: 8px;">
          <img class="pvp-bounty-icon" :src="`${$rHost}/img/common/resource/GOLDICON.png`"
               style="height: 12px;"
               alt="">
          <span class="color-gold-1"
                style="margin-left: 2px; letter-spacing: 1px; font-size: 12px;">
            {{ roomInfo.pvpBounty }}
          </span>
        </div>
      </div>
      <div class="buttons-field">
        <button v-click-sound-button
                type="button"
                class="btn-join h-btn normal small"
                :disabled="roomInfo.isSpectatorsMax"
                @click="joinRoomWatch(roomInfo)">观战
        </button>
        <button v-click-sound-button
                type="button"
                class="btn-join h-btn normal small"
                :disabled="roomInfo.current >= roomInfo.total"
                @click="join(roomInfo)">加入
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  const DRAFT_MODE_NAME = {
    0: '标准',
    1: '角色',
    2: '自由',
  }

  export default {
    data () {
      return {
        DRAFT_MODE_NAME,
      }
    },

    props: {
      roomInfo: {
        type: Object,
        default () {
          return {}
        }
      }
    },

    computed: {
      ...mapGetters('hero', [
        'actionPoint',
      ]),

      ownerNick () {
        const owner = this.roomInfo.players.find((p) => p.id === this.roomInfo.ownerPID)
        return owner?.nick
      },

      isAIRoom () {
        return this.roomInfo.isAIRoom
      }
    },

    methods: {
      ...mapActions('gameSocket', [
        'joinRoom',
        'joinWatch',
      ]),

      // 房间状态 className
      getRoomStatusClassName (room) {
        if (room.current === 1 && !room.locked) {
          return 'open'
        } else if (room.current === 1 && room.locked) {
          return 'locked'
        } else {
          return 'closed'
        }
      },

      // 加入房间
      async join (room) {
        if (this.actionPoint <= 0) {
          this.$message('行动力不足')
          return
        }

        if (!room.locked) {
          this.joinRoom({ roomId: room.id })
          return
        }

        const password = await this.$confirm('输入房间密码', {
          input: true,
          placeholder: '输入密码',
          maxLength: 10,
          validator (content) {
            if (!content) {
              return new Error('未填写密码')
            }
            if (!/^[\w\d]{1,10}$/.test(content)) {
              return new Error('密码错误')
            }
          }
        })
        this.joinRoom({ roomId: room.id, password })
      },

      // 加入观战
     async joinRoomWatch (room) {
        if (!room.locked) {
          this.joinWatch({ roomId: room.id })
          return
        }

        const password = await this.$confirm('输入房间密码', {
          input: true,
          placeholder: '输入密码',
          maxLength: 10,
          validator (content) {
            if (!content) {
              return new Error('未填写密码')
            }
            if (!/^[\w\d]{1,10}$/.test(content)) {
              return new Error('密码错误')
            }
          }
        })
        this.joinWatch({ roomId: room.id, password })
      },
    }
  }
</script>

<style lang="stylus" scoped>
  .room-item
    display flex
    flex-direction column
    margin-top 5px
    padding 4px
    line-height 32px
    font-size 12px
    color #fff
    &:before
      z-index 0 !important

  .row-bottom
    position relative
    display flex
    justify-content space-between
    margin-top 1px
    padding 5px 2px 2px
    &:before
      content ""
      position absolute
      left 0
      top 0
      width 100%
      height 0
      border 0.5px solid #716452
      -webkit-box-shadow 1px 1px 0 #211c10
      box-shadow 1px 1px 0 #211c10
    .status-field
      display flex
      justify-content center
      align-items center
      .h-tag
        letter-spacing 1px
        &:not(:last-child)
          margin-right 2px
    button
      margin-left 5px
      font-family SimSun

  .row-top
    display flex
    padding 1px
    > div
      position relative
      text-align center
    .status
      display flex
      justify-content center
      align-items center
      width 32px
      .room-status-icon
        width 30px
        height 30px
        background-size 100%
        background-repeat no-repeat
        &.open
          background-image btnURL("MUGSOPEN.jpg")
        &.locked
          background-image btnURL("MUGSPASS.jpg")
        &.closed
          background-image btnURL("MUGSCLOS.jpg")
    .progress
      width 30px
      letter-spacing 1px
    .title
      flex-grow 1
      padding 0 10px
      text-align left
      lineClamp(1)
    .button
      width 64px
      .btn-join
        margin 2px 0
        width 60px
        height 28px
        background-size 60px 56px
        line-height 28px
        font-size 12px
        letter-spacing 1px
        color #f8e490
        text-shadow 2px 2px 1px #000
        &:disabled
          color #777
        &:active
          background-position 0 -28px

</style>
